import { MfaCodeField } from "@/features/common/components/MfaCodeField";
import { SelectField } from "@/lib/form/components/SelectField";
import { SubmitButton } from "@/lib/form/components/SubmitButton";
import { TextField } from "@/lib/form/components/TextField";
import { createFormHook, createFormHookContexts } from "@tanstack/react-form";

const { fieldContext, formContext, useFieldContext, useFormContext } = createFormHookContexts();

const { useAppForm } = createFormHook({
	fieldContext,
	formContext,
	fieldComponents: {
		TextField,
		SelectField,
		MfaCodeField
	},
	formComponents: {
		SubmitButton
	}
});

export { useAppForm, useFieldContext, useFormContext };
